import "./ResourceTable.css";

const formatValue = (value) => {
    if (value === null || value === undefined || value === "") {
        return "-";
    }

    if (typeof value === "boolean") {
        return value ? "Sí" : "No";
    }

    if (Array.isArray(value)) {
        return `${value.length} elemento${value.length === 1 ? "" : "s"}`;
    }

    if (typeof value === "object") {
        return value.nombre || value.name || value.descripcion || value._id || value.id || "Objeto";
    }

    const stringValue = String(value);

    if (stringValue.length > 70) {
        return `${stringValue.slice(0, 70)}...`;
    }

    return stringValue;
};

const ResourceTable = ({ columns, rows, emptyMessage }) => {
    if (!rows.length) {
        return (
            <div className="resource-table__empty">
                <strong>No hay datos para mostrar</strong>
                <p>{emptyMessage || "Todavía no existen registros cargados para esta sección."}</p>
            </div>
        );
    }

    return (
        <div className="resource-table__wrapper">
            <table className="resource-table">
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key}>{column.label}</th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows.map((row, index) => (
                        <tr key={row.id || row._id || index}>
                            {columns.map((column) => (
                                <td key={column.key}>
                                    {formatValue(column.render ? column.render(row) : row[column.key])}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ResourceTable;